import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchPlanCheckReference, getAllPlanChckList } from "../../Thunks/PlanCheckThunks";
import { PlanCheck } from "../../Types/PlanCheck/PlanCheckType";
import { PlanCheckReference } from "../../Types/PlanCheck/PlanCheckReference";

interface PlanCheckSliceState {
  loader: boolean; // for refres pages and inital loadings
  planCheckList: PlanCheck[];
  errorDisplay: string | null;

  loadingPlanCheckReference: boolean;
  planCheckReferences: PlanCheckReference | null;
  errorPlanCheckReference: string | null;
}

// set inital valus
const initialState: PlanCheckSliceState = {
  loader: false,
  planCheckList: [],
  errorDisplay: null,

  loadingPlanCheckReference: false,
  planCheckReferences: null,
  errorPlanCheckReference: null,
}

// set state valu for api response
const planCheckSlice = createSlice({
  name: 'planCheckSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      /* Plan check list */
      .addCase(getAllPlanChckList.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })
      .addCase(getAllPlanChckList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getAllPlanChckList.fulfilled, (state, action: PayloadAction<PlanCheck[]>) => {
        state.planCheckList = [];
        state.loader = false;
        state.planCheckList = action.payload;
      })

      /* Plan check reference list */
      .addCase(fetchPlanCheckReference.rejected, (state, action) => {
        state.loadingPlanCheckReference = false;
        state.errorPlanCheckReference = action.error.message!;
      })
      .addCase(fetchPlanCheckReference.pending, state => {
        state.loadingPlanCheckReference = true;
        state.errorPlanCheckReference = null;
      })
      .addCase(fetchPlanCheckReference.fulfilled, (state, action: PayloadAction<PlanCheckReference | null>) => {
        state.planCheckReferences = null;
        state.loadingPlanCheckReference = false;
        state.planCheckReferences = action.payload;
      })
  }
})

export const { } = planCheckSlice.actions
export default planCheckSlice.reducer
